/**
 * Theme and brand colors for the website.
 * Use these instead of hardcoded hex values for consistency.
 */
export const colors = {
  // Primary / referral
  primary: "#A94E76",
  primaryDark: "#8E264E",
  primaryDarker: "#6D1D3A",
  // Secondary
  secondary: "#D88284",
  // Emergency
  emergency: "#D45558",
  emergencyLight: "#D88284",
  // Referral (directory)
  referralLight: "#A94E76",
  referralMain: "#8E264E",
  referralBg: "#fceff7",
  // Guidance
  guidanceMain: "#4E5B36",
  guidanceLight: "#B2AE92",
  // Laws
  lawsMain: "#816EAF",
  lawsLight: "#D4C7E2",
  // Neutrals
  white: "#FFFFFF",
  backgroundLight: "#F6F1F4",
  borderLight: "#fceff7",
  textDark: "#271258",
  // Section backgrounds
  lawsLightBg: "#FFE2E3",
  guidanceLightBg: "#EFF2DC",
  accentPurple: "#BCACE3",
  borderMuted: "#7F3354",
  borderMutedDark: "#6A2B47",
  accentPink: "#AE4971",
  darkBg: "#1A2027",
};

export default colors;
